'use strict';

var linearEasing = require('../../../utils/supports/linear-easing.cjs');
var linear = require('../utils/linear.cjs');
var cubicBezier = require('./cubic-bezier.cjs');
var supported = require('./supported.cjs');
var isBezierDefinition = require('../../../../../../motion-utils/dist/es/easing/utils/is-bezier-definition.cjs');

function mapEasingToNativeEasing(easing, duration) {
    if (!easing) {
        return undefined;
    }
    else if (typeof easing === "function") {
        return linearEasing.supportsLinearEasing()
            ? linear.generateLinearEasing(easing, duration)
            : "ease-out";
    }
    else if (isBezierDefinition.isBezierDefinition(easing)) {
        return cubicBezier.cubicBezierAsString(easing);
    }
    else if (Array.isArray(easing)) {
        return easing.map((segmentEasing) => mapEasingToNativeEasing(segmentEasing, duration) ||
            supported.supportedWaapiEasing.easeOut);
    }
    else {
        return supported.supportedWaapiEasing[easing];
    }
}

exports.mapEasingToNativeEasing = mapEasingToNativeEasing;
//# sourceMappingURL=map-easing.cjs.map
